<ng-container *transloco="let t">


  <h3 *ngIf="!is_live">{{ t('Setup your OK Alone Plan') }}</h3>
  <h3  *ngIf="is_live">{{ t('Update your OK Alone Plan') }}</h3>

  <ng-container *ngIf="contract">

  <div class="col-md-12 col-sm-12" *ngIf="hide_contract_form == true || (is_live && account_type=='Custom')">
    <p>{{ t('To change your plan please email us on') }} <a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a> {{ t('or use the chat box below if available.') }}</p>
  </div>

</ng-container>
  <ng-container *ngIf="plan">

  <div class="row">


    <div class="col-md-6 col-sm-6" *ngIf="form && hide_contract_form == false && account_type!='Custom'">

      @if (hide_contract_form == true || (plan.workers>20 && !updated_plan)) {
          <p>{{ t('To change your plan please email us on') }} <a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a>.</p>
      }
      @else {


      <form [formGroup]="form"  (ngSubmit)="submit()">
        <div class="form-group mb-3">
          <label for="workers">
            {{ t('How many lone workers do you want to monitor?') }}</label>

            <select class="form-select" formControlName="workers" name="workers" (change)="changeWorkers()">
              <option *ngFor="let price of pricing" [ngValue]="price.workers">
                {{price.label}}
              </option>
            </select>

            <!-- Worker reduction message for live plans -->
            <div class="alert alert-warning mt-2" role="alert" *ngIf="worker_reduction_message" [innerHTML]="worker_reduction_message">
            </div>

            <div class="alert alert-info mt-2" role="alert" *ngIf="showSalesContact">
              <p *ngIf="!is_live">
                {{ t('To choose 20+ workers please confirm here and a member of our sales team will reach out to you.') }}
                {{ t('Please email') }} <a href="mailto:sales@ok-alone.com">sales&#64;ok-alone.com</a> {{ t('to find out more information.') }}
              </p>
              <p *ngIf="is_live">
                {{ t('Please reach out to your account manager at') }} <a href="mailto:sales@ok-alone.com">sales&#64;ok-alone.com</a>.
              </p>
              <p *ngIf="pendingSalesWorkers">
                {{ t('Requested workers') }}: <b>{{ pendingSalesWorkers }}</b>
              </p>
              <button type="button" class="btn btn-info text-white btn-sm" (click)="confirmSalesContact()" [disabled]="salesContactSending || salesContactSent">
                <span *ngIf="!salesContactSending && !salesContactSent">{{ t('Confirm') }}</span>
                <span *ngIf="salesContactSending"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></span>
                <span *ngIf="salesContactSent">{{ t('Request sent') }}</span>
              </button>
            </div>

          </div>
          <div class="form-group  mb-3" *ngIf="!is_live">
            <label for="call_plan">{{ t('Do you want extra communication features as well as the iPhone and Android apps?') }}</label>

            <select  class="form-select" formControlName="call_plan" name="call_plan">
              <option *ngFor="let option of call_options" [ngValue]="option.val">{{option.txt}}</option>
            </select>

          </div>
          <!-- <div class="form-group  mb-3" *ngIf="!is_live">
            <label for="monitoring">{{ t('Do you want use our 24/7 Call Center run by our professional response team?') }}</label>

            <select  class="form-select" formControlName="monitoring" name="monitoring" [attr.disabled]="form.value.workers < 20 ? '' : null">
              <option *ngFor="let option of lm_options" [ngValue]="option.val">{{option.txt}}</option>
            </select>

          </div> -->
          <div class="alert alert-warning" role="alert" *ngIf="!is_live && contract.comms_upsell && contract.comms_upsell.length>0 && !form.value.call_plan">
            <div class="row">

              <div class="col-sm-12 text-left">

                <button type="button" class="btn btn-default btn-sm pull-right" data-toggle="modal" data-target="#myModal">
                  <i class="fa fa-info-circle" aria-hidden="true"></i> {{ t('Comms') }} <br/> {{ t('Plan Info') }}
                </button>

                <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ t('To continue using the following features please add the Comms Plan to your contract:') }}



                <ul>
                  <li *ngFor="let upsell of contract.comms_upsell">{{upsell}}</li>
                </ul>

              </div>

            </div>
          </div>

        <div class="card" *ngIf="is_live && !contract.sms_upsell && contract.call_plan==0 && !upsell_done">
          <div class="card-body">
            <div class="row">

              <div class="col-sm-8 text-center">
                {{ t('Do you want extra communication features?') }}
                <!-- Button trigger modal -->
                <button type="button" class="btn btn-default btn-sm" data-toggle="modal" data-target="#myModal">
                  <i class="fa fa-info-circle" aria-hidden="true"></i>
                </button>

                <p *ngIf="account_type!='WorkerPlan'">{{ t('If you want to change your Comms Plan please email us on') }} <a href="mailto:customer.support@ok-alone.com" target="_email">customer.support&#64;ok-alone.com</a> {{ t('or use the chat box below if available.') }}</p>
              </div>
              <div class="col-sm-4 text-center" *ngIf="account_type=='WorkerPlan'">
                <button type="submit" class="btn btn-info text-white"  (click)="upsellSmsCall()"> <i class="fa fa-check" aria-hidden="true"></i> {{ t('Add') }} <br/>{{ t('Comms Plan') }}</button>
              </div>

            </div>
          </div>
        </div>


        <div class="alert alert-warning" role="alert" *ngIf="is_live && upsell_done">
          <div class="row">

            <div class="col-sm-8 text-center">
              {{ t('Thanks for adding the Comms Plan, use the button below to') }} <b>{{ t('Save the Plan') }}</b>
            </div>
            <div class="col-sm-4 text-center">
              <button type="submit" class="btn btn-outline-secondary btn-sm"  (click)="upsellSmsCallCancel()">{{ t('Cancel') }}</button>
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="!is_live && !showSalesContact">
          <div class="col-sm-12 text-center">

            <button type="submit" class="btn btn-info text-white "><i class="fa fa-check" aria-hidden="true"></i> {{ t('Calculate New Plan') }}</button>

          </div>
        </div>

        <div *ngIf="updated_plan && !showSalesContact" class="text-center">
          <div class="col-sm-12">
            <br/>
            <button class="btn btn-success text-white " (click)="savePlan()" [disabled]="sending">
              <i class="fa fa-check" aria-hidden="true"></i> {{ t('Save this Plan') }}
              <span *ngIf="sending"> <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i></span>

            </button><br/><br/>
          </div>
        </div>
      </form>

      }

        </div>

        <div class="col-md-6 col-sm-6 text-center" *ngIf="!plan && loading">
          <br/><br/>
          <i class="fa fa-spinner fa-spin fa-4x" aria-hidden="true"></i>
          <br/><br/>
        </div>

        @if (hide_contract_form == true || (plan.workers > 20 && !is_live && !updated_plan)) {
   
        }
        @else {

        <div class="col-md-6 col-sm-6 text-center okalone-plan" *ngIf="plan && hide_contract_form == false && account_type!='Custom'">

          <p *ngIf="!updated_plan">{{ t('Here is your current plan:') }}</p>
          <p *ngIf="updated_plan">{{ t('Here is what your updated plan would be:') }}</p>



          <!-- Standard Plan Information -->
          <ul class="list-group text-center" *ngIf="account_type=='Standard'">
            <li class="list-group-item">
              <h3><b>{{plan.currency}}{{plan.per_worker}} {{ t('per worker') }}</b></h3>
            </li>
            <li class="list-group-item"><i class="fa fa-users fa-2x"></i><span style="font-size: 16px;">&nbsp;{{ t('up to') }} <b>{{plan.workers}} {{ t('Workers for') }} {{plan.currency}}{{plan.subscription}}/{{ t('month') }}</b></span></li>
            <li *ngIf="plan.live_monitoring_fee==0" class="list-group-item"><i class="fa fa-volume-control-phone fa-2x" aria-hidden="true"></i><span style="font-size: 18px;"> {{ t('Basic Support') }}</span></li>

            <li *ngIf="plan.live_monitoring_fee>0" class="list-group-item"><i class="fa fa-volume-control-phone fa-2x" aria-hidden="true"></i><span style="font-size: 18px;"> {{ t('Call Centre Plan') }}</span><br/>
              <span style="font-size: 16px;"><b>{{plan.live_monitoring_minutes}} {{ t('mins of live monitoring for') }} {{plan.currency}}{{plan.live_monitoring_fee}}/{{ t('month') }}</b></span>
            </li>

            <li *ngIf="plan.call_plan_cost==0" class="list-group-item"><i class="fa fa-mobile-screen fa-2x" aria-hidden="true"></i><span style="font-size: 18px;"> {{ t('iPhone & Android App Only') }}</span></li>

            <li *ngIf="plan.call_plan_cost>0" class="list-group-item"><i class="fa fa-mobile-screen fa-2x" aria-hidden="true"></i><span style="font-size: 18px;"> {{ t('iPhone & Android App') }}</span></li>

            <li *ngIf="plan.call_plan_cost>0" class="list-group-item"><i class="fa fa-mobile-screen fa-2x" aria-hidden="true"></i><span style="font-size: 18px;"> {{ t('Comms Plan Included') }}</span><br/>
              <span style="font-size: 16px;"><b>{{plan.call_plan_inc}} {{ t('calls and SMS for') }} {{plan.currency}}{{plan.call_plan_cost}}/{{ t('month') }}</b></span>

            </li>
            <li class="list-group-item">
              <h3><b style="font-size:0.9em">{{plan.currency}}{{plan.total}} {{ t('Total') }}/{{ t('month') }}</b></h3>
            </li>
          </ul>


          <!-- Worker Plan Info -->
          <ul class="list-group text-center" *ngIf="account_type=='WorkerPlan'">
            <li class="list-group-item">
              <h3><i class="fa fa-users fa-2x"></i><b> {{ t("You've chosen workers", {workers: plan.workers}) }}</b></h3>
              <span style="font-size: 16px;"><b>{{ t("each per month, it's /month to access the system", {currency: plan.currency,per_worker: plan.per_worker,subscription: plan.subscription}) }} </b>
              </span>
            </li>
            <li *ngIf="plan.call_plan==0" class="list-group-item"><i class="fa fa-mobile-screen fa-2x" aria-hidden="true"></i><span style="font-size: 18px;"> {{ t('iPhone & Android App Only') }}</span></li>
            <li *ngIf="plan.call_plan==1" class="list-group-item"><i class="fa fa-mobile-screen fa-2x" aria-hidden="true"></i><span style="font-size: 18px;"> {{ t('iPhone & Android App Included') }}</span></li>
            <li *ngIf="plan.live_monitoring>0" class="list-group-item"><i class="fa fa-phone fa-2x" aria-hidden="true"></i><span style="font-size: 18px;"> {{ t('Call Center Plan') }}</span><br/>
              <span style="font-size: 16px;"><b>{{plan.currency}}{{plan.live_monitoring_fee}} {{ t('per worker/month for call center plan') }}</b></span>
            </li>
            <li *ngIf="plan.call_plan>0" class="list-group-item">
              <i class="fa-regular fa-comment fa-2x"></i><span style="font-size: 18px;"> {{ t('Comms Plan Included') }}</span><br/>
              <span style="font-size: 16px;"><b>{{plan.currency}}{{plan.call_plan_cost}} {{ t('per worker/month for extra communication features') }} </b></span>
              <li class="list-group-item">
                <h1><b style="font-size:0.9em">{{ t("That's /month in total",{currency: plan.currency, total: plan.total}) }}</b></h1>
              </li>
            </ul>

            <br/><br/>
            <a  class="btn btn-outline-secondary" role="button" href="https://www.okaloneworker.com/whats-included-with-your-plan/" target="_new"><i class="fa-regular fa-circle-question"></i> {{ t("What's included with your OK Alone Plan") }} </a>
          

          </div>
        }
        </div>




        <div class="row">
          <div class="col">
            
          
      <div>
        <br/>



        <ul class="nav nav-tabs">
          <li class="nav-item">
            <a class="nav-link" (click)="tabView('pricing')" [class.active]="tab_view=='pricing'">{{ t('About Pricing') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="tabView('sms')" [class.active]="tab_view=='sms'">{{ t('Comms Plan') }}</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="tabView('monitoring')" [class.active]="tab_view=='monitoring'">{{ t('Call Centre Plan') }}</a>
          </li>
        </ul>


        <!-- Tab panes -->
        <div class="tab-content">
          <div role="tabpanel" class="tab-pane active" id="home">

            <p *ngIf="tab_view=='pricing'">
              {{ t('A subscription to the OK Alone system gives you access to the Dashboard for Monitors and the App for Workers. Your subscription fee is based on the number of Workers you choose in the plan.') }}<br/><br/>


              <a href="https://www.okaloneworker.com/what-is-the-worker-plan/" target="_new">{{ t('Learn more about the Worker Plan...') }}</a>
            </p>
            <p *ngIf="!is_live && tab_view=='monitoring' && account_type=='Standard'"> {{ t('You can choose to have our Safety Monitoring Center act as your monitor. You pay for this live monitoring time in minutes. To get the best value, you choose a plan that covers your expected use of the call centre.  If you go over your plan, we don’t cut you off, but surcharges may apply.') }}</p>
            <p *ngIf="!is_live && tab_view=='monitoring' && account_type=='WorkerPlan'"> {{ t('You can choose to have our Safety Monitoring Center act as your monitor. You pay per worker in the account.') }}</p>

            <p *ngIf="is_live&& tab_view=='monitoring'">{{ t('If you want to change your call centre plan please email us on') }} <a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a> {{ t('or use the chat box below if available.') }}</p>

            <p *ngIf="tab_view=='sms'">
              <span *ngIf="account_type=='Standard'">
                {{ t('You may find it helpful to use SMS messages or automated phonecalls for worker reminders or monitor alerts. SMS/call credit plans are also designed to suit your needs and offer the best value.  Again, if you go over your plan, the system will continue to work for you, but additional fees will apply.') }}

                <p *ngIf="is_live&& tab_view=='sms'">{{ t('If you want to change your Comms Plan please email us on') }} <a href="mailto:customer.support@ok-alone.com" target="_new">customer.support&#64;ok-alone.com</a> {{ t('or use the chat box below if available.') }} </p>

              </span>
              <span *ngIf="account_type=='WorkerPlan'">
                <p>{{ t('OK Alone offers extra communication features to contact your monitors and workers.') }}</p>
                <p><b>{{ t('Workers:') }}</b></p>
                <ul>
                  <li>{{ t('Start shift reminders by SMS or WhatsApp') }}</li>
                  <li>{{ t('End shift reminders by SMS or WhatsApp') }}</li>
                  <li>{{ t('Check in reminders by SMS or WhatsApp') }}</li>
                  <li>{{ t('Check in reminders by Auto-phone call') }}</li>
                  <li>{{ t('Bulk SMS messages to all workers with an important message') }}</li>
                </ul>
                <p><b>{{ t('Monitors:') }}</b></p>
                <ul>
                  <li>{{ t('Extra notifications for missed shifts and alert loops') }}</li>
                </ul>
                <b>{{ t('Alert Loops:') }}</b><br/>
                <ul>
                  <li>{{ t('An Alert Loop is an automated system that cycles through a set list of monitors until one of them accepts responsibility for resolving the alert.') }}</li>
                </ul>
                <b>{{ t('Out of Hours Alerts:') }}</b><br/>
                <ul>
                  <li>{{ t('Our Out of Hours Alerts service lets you choose the monitors that should be alerted, if the alert occurs out of normal business hours.') }}</li>
                </ul><br/>
                <a href="https://www.okaloneworker.com/work-alone-monitoring-pricing/" target="_new">{{ t('Learn more about the Communication Plan...') }}</a>
              </span>
            </p>


          </div>

            </div>

          </div>


          </div>

        </div>
      </ng-container>
</ng-container>
